import { Injectable, inject } from '@angular/core'
import { ApiClient } from '@ftr/api-shared'
import { Uuid } from '@ftr/contracts/type/shared'
import { Observable } from 'rxjs'
import { PlaybackApiClientFactory } from './playback-api-client.factory'

@Injectable({
  providedIn: 'root',
})
export class PlaybackApiClientSetupService {
  protected readonly playbackApiClientFactory = inject(PlaybackApiClientFactory)

  readonly playbackApiClientMap = new Map<string, Observable<ApiClient>>()

  playbackApiClient(path: string, courtSystemId: Uuid): Observable<ApiClient> {
    const uniqueKey = `${path}-${courtSystemId}`
    if (!this.playbackApiClientMap.has(uniqueKey)) {
      this.playbackApiClientMap.set(uniqueKey, this.playbackApiClientFactory.buildForCourt(path, courtSystemId))
    }
    return this.playbackApiClientMap.get(uniqueKey)!
  }
}
